module.exports = __webpack_public_path__ + "img/fashion_66.d1814865.jpg";